// @ts-check
import { LitElement, html, css } from 'lit';
import { classMap } from 'lit-html/directives/class-map'
export class VoyageButton extends LitElement {
    constructor() {
        super();
        this.toggled = false;
        this.disabled = false;
        this.size = undefined;
        this.variant = undefined;
        this.focused = false;
    }

    static get properties() {
        return {
            toggled: { type: Boolean },
            disabled: { type: Boolean },
            size: { type: String },
            variant: { type: String },
            focused: { type: String }
        }
    }

    static get styles() {
        return [
            css`
            :host {
                display: block;
            }

            :host([disabled]) > button {
                cursor: not-allowed;
            }

            :host([toggled]) > button {
                background: var(--neutrals-grey-08, grey);
                border: 1px solid var(--neutrals-grey-04, black);
            }

            button {
                width: 100%;
                height: 100%;
                padding: 0 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                box-sizing: border-box;
                background: #FFFFFF;
                border-radius: 3px;
                border: 1px solid var(--neutrals-grey-06, black);
                cursor: pointer;
            }

            button:focus,
            button:active {
                outline: none;
            }

            button.sm {
                padding: 8px;
            }

            button.lg {
                padding: 16px;
            }

            button.primary {
                background-color: var(--primary-blue-05);
                color: white;
            }

            button[focused] {
                background-color: var(--functional-grey-400);
            }
        `];
    }

    render() {
        const classes = {
            [this.variant]: true,
            [this.size]: true
        }

        return html`
            <button ?focused=${this.focused} class=${classMap(classes)} @click="${this.clickHandler}">
                <slot></slot>
            </button>
        `;
    }

    clickHandler(evt) {
        if (this.disabled) {
            evt.stopPropagation();
        }
    }
};

customElements.define('voyage-button', VoyageButton);
